export default "__VITE_ASSET__7a190465__"